// Константы раздела «Табель РБ». Размеры страницы и границы причины совпадают с серверными (backend/services/timesheet.js)
import {
  CycleAction, EventResult, FileSource, RunItemResult, RunKind, RunStatus, SortState, StatusFilter, TimesheetFilters, TriggerType
} from './types';

export const PAGE_SIZES = [10, 25, 50, 100];
/** Причина операции («зачем»): обязательна для смены папки и года, массовых действий и операций цикла */
export const REASON_MIN = 3;
export const REASON_MAX = 500;
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_SORT: SortState = { sortBy: 'pharmacy', sortOrder: 'asc' };
export const EMPTY_FILTERS: TimesheetFilters = { search: '', status: '' };
export const SEARCH_DELAY_MS = 300;
/** Как часто спрашивать ход массового создания, пока запуск идёт */
export const RUN_POLL_MS = 2500;

export const STATUS_OPTIONS: Array<{ value: StatusFilter; label: string }> = [
  { value: '', label: 'Все аптеки' },
  { value: 'created', label: 'Табель создан' },
  { value: 'missing', label: 'Табеля нет' }
];

export const SOURCE_LABELS: Record<FileSource, string> = {
  run: 'Массовое создание',
  single: 'Из раздела',
  account: 'При регистрации аптеки',
  sync: 'Найден в папке'
};

export const RUN_STATUS_LABELS: Record<RunStatus, string> = {
  running: 'Выполняется',
  done: 'Завершён',
  cancelled: 'Остановлен',
  failed: 'С ошибкой',
  interrupted: 'Прерван'
};

export const RUN_STATUS_COLORS: Record<RunStatus, 'info' | 'success' | 'warning' | 'error' | 'default'> = {
  running: 'info',
  done: 'success',
  cancelled: 'warning',
  failed: 'error',
  interrupted: 'warning'
};

export const RUN_KIND_LABELS: Record<RunKind, string> = {
  create: 'Создание недостающих',
  prepare: 'Подготовка нового года'
};

export const TRIGGER_LABELS: Record<TriggerType, string> = {
  manual: 'Вручную',
  schedule: 'По расписанию'
};

export const RUN_ITEM_LABELS: Record<RunItemResult, string> = {
  created: 'Создан',
  exists: 'Уже был',
  failed: 'Ошибка'
};

export const RUN_ITEM_COLORS: Record<RunItemResult, string> = {
  created: '#166534',
  exists: '#475569',
  failed: '#b91c1c'
};

/** Типы событий журнала операций (timesheet_events.type) */
export const EVENT_TYPE_LABELS: Record<string, string> = {
  settings_changed: 'Смена папки и года',
  cycle_settings_changed: 'Настройки автоматизации',
  folder_created: 'Создана папка года',
  folder_exists: 'Выбрана существующая папка года',
  prepare_started: 'Подготовка табелей года',
  run_started: 'Создание недостающих табелей',
  switched: 'Переключение года',
  switch_postponed: 'Переключение отложено',
  auto_error: 'Сбой автоматизации'
};

export const EVENT_RESULT_LABELS: Record<EventResult, string> = {
  success: 'Выполнено',
  error: 'Ошибка',
  skipped: 'Отложено'
};

export const EVENT_RESULT_COLORS: Record<EventResult, 'success' | 'error' | 'warning'> = {
  success: 'success',
  error: 'error',
  skipped: 'warning'
};

/** Ближайшее действие автоматизации (решение timesheetCycle.plan); {year} подставляется на экране */
export const PLAN_LABELS: Record<CycleAction, string> = {
  none: 'Действий не требуется',
  prepare: 'Нужно подготовить {year} год: создать папку и табели',
  fill_next: 'Нужно досоздать недостающие табели {year} года',
  switch: 'Наступил {year} год: нужно переключить год табелей',
  fill_current: 'Нужно досоздать недостающие табели {year} года: пока доступен прошлый год'
};

export const MONTH_NAMES = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
];

/** Зона оператора на момент запуска (значение скоупа права «Вывод данных») */
export const SCOPE_LABELS: Record<string, string> = {
  all: 'Вся сеть',
  assigned_pharmacies: 'Курируемые аптеки',
  own_region: 'Свой регион'
};

export const hasAnyFilter = (f: TimesheetFilters): boolean => Boolean(f.search.trim()) || Boolean(f.status);
